<div [ngClass]="{'txt-muted': APP_BRAND.NAME === 'RSD'}">

  <fileupload
    visibleByBrand="maja"
    [(files)]="uploadingFiles"
    [disabled]="false"
    [message]="'Vložte nové dokumenty přetažením, nebo je vyberte z počítače.'"
    [draggable]="draggable"
    (change)="onFileSelect($event)"
    *ngIf="canModify('manipulate_files')"
  ></fileupload>

  <div visibleByBrand="mpv" class="text-center mt-30 mb-30 txt-normal">
    <i class="fa fa-exclamation-triangle error-message"></i>
    Dočasné zobrazení původního stavu nahraných souborů do MPV. Se soubory nelze manipulovat, jsou zobrazeny pro kontrolu migrace dokumentů do EPD.
  </div>

  <ng-container *ngIf="attachmentList">
    <div class="mb-10" [gmtAuth]="'admin'">
      <div class="tag"
           [ngClass]="{active: checkCancelled()}"
           title="Zobrazení uživateli zrušených dokumentů"
           (click)="onCancelledCheckboxClicked()"
      >Zobrazit zrušené</div>
    </div>

    <div [loading]="attachmentList.loading">
      <div class="bordered" *ngIf="attachmentList.itemCount">
        <table >
          <thead>
          <tr>
            <th>
              <sort-by
                [selected]="'name' === attachmentList.filter.sortOrder.sortBy"
                [sortDir]="attachmentList.filter.sortOrder.direction"
                (sort)="onSort('name', attachmentList.filter.sortOrder.direction)">
                Název
              </sort-by>
            </th>
            <th>
              Poznámka
            </th>
            <th>
              <sort-by
                [selected]="'createdUser.name' === attachmentList.filter.sortOrder.sortBy"
                [sortDir]="attachmentList.filter.sortOrder.direction"
                (sort)="onSort('createdUser.name', attachmentList.filter.sortOrder.direction)">
                Nahrál
              </sort-by>
            </th>
            <th>
              <sort-by
                [selected]="'timestamp' === attachmentList.filter.sortOrder.sortBy"
                [sortDir]="attachmentList.filter.sortOrder.direction"
                (sort)="onSort('timestamp', attachmentList.filter.sortOrder.direction)">
                Datum nahrání
              </sort-by>
            </th>
            <th>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let attachment of attachmentList.list" [ngClass]="{cancelled: attachment.cancelled}">
            <td class="attachment-item">
              <div>
                <div>
                  <a visibleByBrand="maja" href="{{restBaseUrl}}/attachments/{{attachment.id}}/data?t={{authToken}}">
                    <i class="mr-10 fa fa-lg flex-icon {{attachment | attachmentType : 'icon'}}"></i>
                  </a>
                  <i visibleByBrand="mpv" class="mr-10 fa fa-lg flex-icon {{attachment | attachmentType : 'icon'}}"></i>
                </div>
                <div>
                  <a visibleByBrand="maja" href="{{restBaseUrl}}/attachments/{{attachment.id}}/data?t={{authToken}}">
                    {{attachment.baseName + (attachment.extension ? '.' + attachment.extension : '')}}
                  </a>
                  <span visibleByBrand="mpv">
                    {{attachment.baseName + (attachment.extension ? '.' + attachment.extension : '')}}
                  </span>

                  <p>{{attachment | attachmentType : 'title'}}</p>
                  <p>id: {{attachment.id}}</p>
                </div>
              </div>
            </td>
            <td>
              {{attachment.note}}
            </td>
            <td>
              {{attachment.createdUser | username}}
            </td>
            <td>
              {{attachment.timestamp | date : 'short'}}
            </td>
            <td>
              <div class="fr">
                <a *ngIf="mapEnabled && fileType(attachment, 'vfk')" uiSref="symap.project.map" [uiParams]="{ document: attachment.id, tool: 'gp-vfk' }" title="Náhled VFK v mapě" class="mr-10" target="_blank"><i class="fa fa-map fa-lg"></i></a>
                <a *ngIf="attachment.canViewPDF" href="{{getAttachmentUrl(attachment)}}" title="Náhled dokumentu" target="_blank" class="mr-10"><span class="fa fa-eye fa-lg"></span></a>
                <span visibleByBrand="maja" *ngIf="canModify('manipulate_files', attachment.createdUser)">
                  <a *ngIf="!attachment.cancelled" (click)="onEditAttachment(attachment)" title="Upravit"><span class="fa fa-pencil fa-lg"></span></a>
                  <a *ngIf="!attachment.cancelled" (click)="onDeleteAttachment(attachment)" title="Odstranit" class="remove-document"><span class="fa fa-trash-o fa-lg"></span></a>
                </span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="bordered" *ngIf="!attachmentList.itemCount">
        <div class="empty-info">
          <span>Žádné dokumenty</span>
        </div>
      </div>
    </div>
  </ng-container>
</div>
